import angular from 'angular'

import saleCtrl from './sale.controller'
import saleRoutes from './sale.routes'
import saleRun from './sale.run'

const name = 'routingScrappingSale'

angular.module(name, [])
  .controller('saleCtrl', saleCtrl)
  .config(saleRoutes)
  .run(saleRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/sale/sale.module.js